import de from '@translations/de/confirmationPopup.json';
import en from '@translations/en/confirmationPopup.json';
import pl from '@translations/pl/confirmationPopup.json';
import sl from '@translations/sl/confirmationPopup.json';
import uk from '@translations/uk/confirmationPopup.json';
import bg from '@translations/bg/confirmationPopup.json';
import cz from '@translations/cz/confirmationPopup.json';
import fr from '@translations/fr/confirmationPopup.json';
import gr from '@translations/gr/confirmationPopup.json';
import it from '@translations/it/confirmationPopup.json';
import pr from '@translations/pr/confirmationPopup.json';
import ru from '@translations/ru/confirmationPopup.json';
import sk from '@translations/sk/confirmationPopup.json';
import sp from '@translations/sp/confirmationPopup.json';
import tr from '@translations/tr/confirmationPopup.json';
import hu from '@translations/hu/confirmationPopup.json';
import { ITranslations } from '@/types/common';
import { ConfirmationPopupTransFields } from './types';

export const confirmationPopupTranslations: ITranslations<ConfirmationPopupTransFields> = {
  name: 'confirmationPopup',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
